import { authRoles } from 'app/auth';
import InfrastructureElementTable from './table/InfrastructureElementTable';
import InfrastructureElementEditForm from './editform/InfrastructureElementEditForm';

export default [
	{
		path: '/infrastructure-element/edit/:id',
		component: InfrastructureElementEditForm,
		auth: authRoles.infrastructureElement
	},
	{
		path: '/infrastructure-element/:sessionNameParam?',
		component: InfrastructureElementTable,
		auth: authRoles.infrastructureElement
	}
];
